import { FC, useEffect, useState } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import V2Pagination from '@/common/components/Data/V2Pagination';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import { getDynamicDetail, getStandardChancePointPageByCluster } from '@/common/api/expandStore/chancepoint';
import { analysisTableTitle } from '@/common/components/business/DynamicComponent/config';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
// import { useBigdataFn } from '@/common/utils/bigdata';
import ChancePointDetail from '@/common/components/business/ExpandStore/ChancePointDetail';
import ChancePointItem from './ChancePointItem';
import styles from './index.module.less';

export interface ChanceListProps {
  detail?: any;
  viewChanceDetail?: boolean;
  chancepointAlias?: string;
  isShare?: boolean; // 分享页场景
  tenantId?: number; // 分享页场景
  employeeId?: number; // 分享页场景
}

/**
 * @Description 商圈详情-机会点列表
 */
const ChanceList: FC<ChanceListProps> = ({
  detail,
  viewChanceDetail,
  chancepointAlias,
  isShare,
  tenantId,
  employeeId,
}) => {

  const {
    /** 当前租户的拓店任务模板是否“加盟+直营B（一鸣）”，未确定时为null */
    isStandardAndClusterBTaskTemplate,
  } = useTenantCheckInfo();

  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [totalNum, setTotalNum] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<any>(1); // 当前页数
  const [pageSize, setPageSize] = useState<any>(3); // 当前页长
  const [chanceId, setChanceId] = useState<any>(0); // 机会点id
  const [list, setList] = useState<any>([]); // 机会点数据
  const [drawerVisible, setDrawerVisible] = useState<boolean>(false); // 机会点详情是否可见
  const [loading, setLoading] = useState<any>(false); // 当前页数

  const [formDrawerData, setFormDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  });
  const [refreshDetail, setRefreshDetail] = useState<number>(0);

  useEffect(() => {
    detail.id && methods.loadData({});
  }, [detail]);

  const methods = useMethods({
    // 分页相关
    handlePageChange: (value: any, pageSize: number) => {
      setCurrentPage(value);
      setPageSize(pageSize);
      methods.loadData({ page: value, pageSize: pageSize });
    },

    loadData: async (params) => {
      let _params: any = {
        page: params?.page || currentPage,
        size: params?.pageSize || pageSize,
        modelClusterId: detail.id,
        dynamicTemplateType: 2, // 动态表头模版类型 ： 1：机会点， 2:选址地图商圈  默认1
        distance: 500,
        longitude: detail?.lng,
        latitude: detail?.lat,
        ...(isShare ? { tenantId, userId: employeeId } : {}),
      };

      setLoading(true);
      const renderResult: any[] = [];

      let targetFetch = getDynamicDetail;
      if (isStandardAndClusterBTaskTemplate) { // 暂时只在“加盟+直营B（一鸣）”任务模板下使用
        _params = {
          id: detail.id,
          page: params?.page || currentPage,
          size: params?.pageSize || pageSize,
        };
        targetFetch = getStandardChancePointPageByCluster;
      }
      const { objectList, totalNum } = await targetFetch(_params).finally(() => setLoading(false));
      objectList?.forEach(item => {
        const { columns } = item;
        const columnArr = isArray(columns) ? columns.map((i) => {
          const res = analysisTableTitle(i);
          return {
            name: i.propertyName,
            value: res
          };
        }) : [];
        renderResult.push({
          ...item,
          columns: columnArr
        });
      });

      setTotalNum(totalNum);
      setList(renderResult || []);
    },
    onClick(val: any) {
      if (viewChanceDetail) {
        setChanceId(val.id);
        setDrawerVisible(true);
        // bigdataFn('175bd30e-7e00-4eb9-92a3-03034f356320', '详情-机会点-查看详情', '点击了详情-机会点-查看详情', { op_block: '开店区域-详情页', op_event: ``, });
      }
    }
  });

  return (
    totalNum
      ? <div className={styles.chanceList}>
        <V2Title divider type='H2' text={`${chancepointAlias || '机会点'}(${totalNum})`}/>
        {list?.map(item => {
          return <ChancePointItem key={item.id} detail={item} onClick={methods.onClick} className={viewChanceDetail ? 'pointer' : ''}/>;
        })}
        {totalNum > pageSize
          ? <V2Pagination
            simple={true}
            disabled={loading}
            current={currentPage}
            total={totalNum}
            onChange={methods.handlePageChange}
            pageSize={pageSize}
          /> : '' }

        <ChancePointDetail
          pointId={chanceId}
          detailVisible={drawerVisible}
          setFormDrawerData={setFormDrawerData}
          setDetailVisible={setDrawerVisible}
          refreshDetail={refreshDetail}
          formDrawerData={formDrawerData}
          onSearch={methods.loadData}
          updateHandle={() => setRefreshDetail(refreshDetail + 1)}
        />
      </div>
      : <></>
  );
};

export default ChanceList;
